import React from 'react';

import { Card, CardBody, CardCoverPhoto } from '@react/react-spectrum/Card';

export default function AEPCard({ data }) {
  return (
    <Card allowsSelection={false}>
      <CardCoverPhoto src={getSolutionImage(data.sandboxName)} />
      <CardBody title={data.sandboxName} subtitle="Experience Platform" />
    </Card>
  );
}

function getSolutionImage(name) {
  let number = (name.length % 3) + 1;

  return `https://demo-system-dashboard.s3.eu-north-1.amazonaws.com/images/experience-${number}.jpg`;
}
